import React from 'react';
import Card from '../../Common/Card';
import DetailsRow from '../../Customer/Details/DetailsRow';
import TenantService from '../../../Service/TenantService';
import { hot } from 'react-hot-loader';

export default hot(module)(
	class Details extends React.Component {
		constructor(props) {
			super(props);
			this.state = {
				_tenant: null
			};
		}

		setCurrency = currency => {
			const typeMap = {
				1: <span className="badge badge-pill badge-info">PHIL-PESO</span>,
				default: 'None'
			};
			return typeMap[currency] || typeMap.default;
		};

		setAllTenants = async () => {
			const response = await TenantService.getById(this.props.match.params.id);
			this.setState({
				_tenant: response
			});
		};

		componentDidMount() {
			this.setAllTenants();
		}

		render() {
			if (!this.state._tenant) {
				return 'Loading...';
			}
			const displayRow = [
				{
					label1: 'Full Name',
					value1: this.state._tenant.full_name,
					label2: 'Min Interest',
					value2: this.state._tenant.min_interest_percentage
				},
				{
					label1: 'Short Name',
					value1: this.state._tenant.short_name,
					label2: 'Max Interest',
					value2: this.state._tenant.max_interest_percentage
				},
				{
					label1: 'Default Language',
					value1: this.state._tenant.default_language,
					label2: 'Min Amount',
					value2: this.state._tenant.min_amount
				},
				{
					label1: 'Default Time Zone',
					value1: this.state._tenant.default_time_zone,
					label2: 'Max Amount',
					value2: this.state._tenant.max_amount
				},
				{
					label1: 'Default Currency',
					value1: this.setCurrency(this.state._tenant.default_currency),
					label2: 'id',
					value2: this.state._tenant.id
				},
				{
					label1: 'Installment Factor',
					value1: this.state._tenant.pre_field_installment_factor,
					label2: 'Max Installment Factor',
					value2: this.state._tenant.max_pre_field_installment
				},
				{
					label1: 'Emi Service Fee',
					value1: this.state._tenant.emi_service_fee,
					label2: 'Principal Service Fee',
					value2: this.state._tenant.principal_service_fee
				},
				{
					label1: 'custom_field1',
					value1: this.state._tenant.custom_field1,
					label2: 'custom_field2',
					value2: this.state._tenant.custom_field2
				}
			];
			return (
				<Card>
					{displayRow.map(row => (
						<DetailsRow key={`${this.state._tenant.id}${row.label1}`} {...row} />
					))}
				</Card>
			);
		}
	}
);
